import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { openFromNotification } from './push';

/**
 * What a tap on a notification DOES — switch to its society, then open Home.
 *
 * A hook so the two places that can be tapped (the system notification, via
 * `PushBridge`, and the in-app pill) run the same handler. They used to be the
 * same three lines written twice, which is how a tap on one starts behaving
 * differently from a tap on the other.
 */
export const useNotificationTap = () => {
  const navigate = useNavigate();
  const { userProfile, setCurrentSociety } = useAuth();
  return useCallback(
    (data) => openFromNotification(data, { navigate, setCurrentSociety, userProfile }),
    [navigate, setCurrentSociety, userProfile],
  );
};

export default useNotificationTap;
